export const LARGE_LAPTOP_AND_DESKTOP = '(min-width: 1200px)';
export const MOBILE_AND_TABLET_PORTRAIT = '(max-width: 991px)';
export const TABLET = '(min-width: 768px) and (max-width: 1199px)';
export const TABLET_PORTRAIT = '(min-width: 768px) and (max-width: 991px)';
export const MOBILE_AND_TABLET = '(max-width: 1199px)';
export const MOBILE = '(max-width: 767px)';
export const XS_MOBILE = '(max-width: 575px)';
export const SMALL_DESKTOP = '(max-width: 1600px)';
